export class CheckboxModel {
    Id = 0;
    Name = '';
    IsSystemObject = false;
    Checked = false;
    IsEnabled = true;
    ChildItems = [];
    ParentId = null;
    DataChildItemField = 'ChildItems';
    OnBeforeClick: (currentChecked: boolean) => Promise<any>;

    constructor(data?) {
        if (data) this.Initialize(data);
    }

    Initialize(item) {
        this.Id = item.Id ? item.Id : 0;
        this.Name = item.Name ? item.Name : '';
        this.IsSystemObject = item.IsSystemObject || false;
        this.Checked = item.Checked ? item.Checked : false;
        this.IsEnabled = item.IsEnabled ? item.IsEnabled : true;
        this.ChildItems = item.ChildItems ? item.ChildItems : [];
        this.ParentId = item.ParentId ? item.ParentId : null;
        this.DataChildItemField = item.DataChildItemField || 'ChildItems';
    }
}
